import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navItems } from "../data/site";
import { IconMenu } from "./icons";
import MobileNavDrawer from "./MobileNavDrawer";
import styles from "./SiteHeader.module.css";

export default function SiteHeader() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <header className={[styles.header, styles.solid].join(" ")}>
      <div className={styles.inner}>
        <button
          type="button"
          className={styles.menuBtn}
          onClick={() => setDrawerOpen(true)}
          aria-label="Open menu"
        >
          <IconMenu />
        </button>

        <Link className={styles.brand} to="/" aria-label="UPSHOT Architecture — home">
          <span className={styles.brandMark}>
            <svg viewBox="0 0 28 28" width="28" height="28" aria-hidden="true">
              <path
                d="M4 22 L14 6 L24 22 M9 22 L14 14 L19 22"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className={styles.brandWord}>UPSHOT</span>
          <span className={styles.brandSub}>Architecture</span>
        </Link>

        <nav className={styles.nav} aria-label="Primary">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                [styles.navItem, isActive ? styles.active : ""].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/contact" className={styles.cta}>
          <span className={styles.ctaFull}>Start a Project</span>
          <span className={styles.ctaShort}>Contact</span>
        </Link>
      </div>

      <MobileNavDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </header>
  );
}
